const subcollection = document.querySelector('.collection-block-subcollections');
let url = new URL(window.location.href);
let params = new URLSearchParams(url.search);

function updateLinks() {
    if (subcollection && !subcollection.closest('.subcollection-area-rugs')) {
        url = new URL(window.location.href);
        params = new URLSearchParams(url.search);
        const subParam = getParams() ? '?' + getParams() : '';
        subcollection.querySelectorAll('a').forEach(subLink => {
            subLink.href = `${subLink.dataset.url}${subParam}`;
        });
    }
}

function getParams() {
    let temp = '';
    params.forEach((value, key) => {
        temp += `${key}=${value}&`;
    });
    return temp.slice(0, -1);
} 

document.addEventListener('DOMContentLoaded', () => {
    updateLinks();
});

const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
            updateLinks();
        }
    }
});

const targetNode = document.querySelector('#sr-root');
const config = { childList: true, subtree: true, attributes: true };

if (targetNode) {
    observer.observe(targetNode, config);
} 